import React from 'react';
import { motion } from 'framer-motion';
import { SectionHeading } from './ui/SectionHeading';
import { modules } from '../data/modules';
import { totalVolumes } from '../data/offer';
export function ModulesSection() {
  return <section className="py-16 sm:py-20" aria-labelledby="modules-title" data-id="element-118" data-mp="1iwcxjc03p0fu">
      <div className="mx-auto max-w-6xl px-4" data-id="element-119" data-mp="1dx07kidxnd91">
        <SectionHeading id="modules-title" data-id="element-120" data-mp="1dybakfzk0gz3">I {totalVolumes} <span className="text-celeste" data-id="element-121" data-mp="2bkihhwjbylem">Volumi Completi</span></SectionHeading>

        <div className="mt-10 grid gap-5 md:grid-cols-2 lg:grid-cols-3" data-id="element-122" data-mp="26lfaw7npc74j">
          {modules.map((module, index) => {
          const Icon = module.icon;
          return <motion.article key={module.title} initial={{
            opacity: 0,
            y: 16
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true,
            amount: 0.15
          }} transition={{
            duration: 0.3,
            delay: index % 3 * 0.05,
            ease: [0.23, 1, 0.32, 1]
          }} className="flex flex-col rounded-2xl border border-celeste/20 bg-ink/55 p-6 shadow-lg shadow-black/30 backdrop-blur-md" data-id="element-123" data-mp="21k83i9ph19ye" data-mpi={index}>
                <div className="flex items-center gap-3" data-id="element-124" data-mp="1ns8yacbtx3x6">
                  <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-xl border border-celeste/40 bg-abyss/60 text-celeste" data-id="element-125" data-mp="18w13ki2sok3n">
                    <Icon className="h-5 w-5 drop-shadow-[0_0_6px_rgba(94,200,242,0.55)]" aria-hidden="true" data-id="element-126" data-mp="1dxyttw9m4f63" />
                  </span>
                  <p className="text-xs font-bold uppercase tracking-[.14em] text-gold" data-id="element-127" data-mp="14vz8irrkeoxc">Volume {module.number}</p>
                </div>
                <h3 className="mt-4 text-xl font-extrabold uppercase leading-tight text-white" data-id="element-128" data-mp="q84khooi58ql">{module.title}</h3>
                <p className="mt-3 text-sm leading-relaxed text-mist" data-id="element-129" data-mp="v3ju24fh8ih7">{module.summary}</p>
              </motion.article>;
        })}
        </div>
      </div>
    </section>;
}